import React, { ReactElement, ReactNode } from "react";

/**
 * Renders a list of button items.
 *
 * This function takes children elements (which can be a single ReactNode 
 * or an array of ReactNodes) and maps them to list items (<li>) 
 * with unique keys.
 *
 * @param {ReactNode | ReactNode[]} children - The button items to render.
 * @returns {ReactElement | null} A React fragment containing a list of 
 *          <li> elements, each wrapping a child.
 */
export const renderButtonItem = (children: ReactNode | ReactNode[]) => {
  return (
    <>
      {
        // Use React.Children.map to iterate over children and render them as list item and key
        React.Children.map(children, (child, index): ReactElement | null => {
          return <li key={index}>{child}</li>;
        })
      }
    </>
  );
}
